import React, { useState } from 'react';
import {
  MonitorCheck, Heart, AlertTriangle, Target, GraduationCap,
  KeyRound, Calculator, BarChart3, TrendingUp, DollarSign, History,
  Package, Wifi, Wrench,
} from 'lucide-react';
import SystemStatus from './SystemStatus';
import { LicenseTracker, BudgetPlanner } from './LicenseAndBudget';
import { IndustryBenchmarks, ScheduledReports, RoiCalculator, SpendAnalytics, ChangelogViewer } from './AnalyticsFeatures';
import { VendorHealth, IncidentLog, TrainingLinks, SlaTracking } from './VendorOps';
import { AssetInventory, InfrastructureMap } from './EnterpriseFeatures';
import FinancialHub from './FinancialHub';
import SidebarLayout from './SidebarLayout';

const TOOL_GROUPS = [
  { label: 'Financial', items: [
    { id: 'financial', label: 'Financial Hub', icon: DollarSign },
  ]},
  { label: 'Monitoring', items: [
    { id: 'system-status', label: 'System Status', icon: MonitorCheck },
    { id: 'vendor-health', label: 'Vendor Health', icon: Heart },
    { id: 'sla-tracking', label: 'SLA Tracking', icon: Target },
    { id: 'incidents', label: 'Incident Log', icon: AlertTriangle },
  ]},
  { label: 'Planning', items: [
    { id: 'licenses', label: 'License Utilization', icon: KeyRound },
    { id: 'budget', label: 'Budget Planning', icon: Calculator },
    { id: 'roi', label: 'ROI Calculator', icon: TrendingUp },
  ]},
  { label: 'Analytics', items: [
    { id: 'benchmarks', label: 'Industry Benchmarks', icon: BarChart3 },
    { id: 'spend', label: 'Spend Analytics', icon: DollarSign },
    { id: 'changelog', label: 'Changelog', icon: History },
  ]},
  { label: 'Infrastructure', items: [
    { id: 'assets', label: 'Asset Inventory', icon: Package },
    { id: 'infrastructure', label: 'Network & Infra', icon: Wifi },
    { id: 'training-links', label: 'Training Links', icon: GraduationCap },
  ]},
];

export default function ToolsHub({ token, role }) {
  const [section, setSection] = useState('financial');

  return (
    <SidebarLayout title="Tools" icon={Wrench} groups={TOOL_GROUPS} activeId={section} onSelect={setSection}>
      {section === 'financial' ? <FinancialHub token={token} role={role} />
      : section === 'system-status' ? <SystemStatus token={token} />
      : section === 'vendor-health' ? <VendorHealth token={token} />
      : section === 'sla-tracking' ? <SlaTracking token={token} />
      : section === 'incidents' ? <IncidentLog token={token} />
      : section === 'licenses' ? <LicenseTracker token={token} />
      : section === 'budget' ? <BudgetPlanner token={token} />
      : section === 'roi' ? <RoiCalculator token={token} />
      : section === 'benchmarks' ? <IndustryBenchmarks token={token} />
      : section === 'spend' ? <SpendAnalytics token={token} />
      : section === 'changelog' ? <ChangelogViewer token={token} />
      : section === 'assets' ? <AssetInventory token={token} />
      : section === 'infrastructure' ? <InfrastructureMap token={token} />
      : section === 'training-links' ? <TrainingLinks token={token} />
      : null}
    </SidebarLayout>
  );
}
